module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point02_03_winter-e75284bfff8a4d815b16a61085a8bf8d.jpg";